import { lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import type { RouteObject } from 'react-router-dom';

import MainLayout from '@/layouts/MainLayout';
import { AuthGuard, ErrorBoundary } from '@/components';

// 懒加载页面组件
const PageLogin = lazy(() => import('@/pages/login'));
const PageDashboard = lazy(() => import('@/pages/dashboard'));
const PageVehicles = lazy(() => import('@/pages/vehicles'));
const PageStations = lazy(() => import('@/pages/stations'));
const PageStops = lazy(() => import('@/pages/stops'));
const PageDispatch = lazy(() => import('@/pages/dispatch'));
const PageMonitor = lazy(() => import('@/pages/monitor'));
const PageLogs = lazy(() => import('@/pages/logs'));
const PageSettings = lazy(() => import('@/pages/settings'));

// 加载中组件
const Loading = () => (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: 300 }}>
        <Spin size="large" tip="加载中..." />
    </div>
);

// 包装懒加载组件（含错误边界和加载状态）
const LazyComponent = ({ Component }: { Component: React.LazyExoticComponent<React.FC> }) => (
    <ErrorBoundary>
        <Suspense fallback={<Loading />}>
            <Component />
        </Suspense>
    </ErrorBoundary>
);

const routes: RouteObject[] = [
    {
        path: '/login',
        element: <LazyComponent Component={PageLogin} />,
    },
    {
        path: '/',
        element: (
            <AuthGuard>
                <MainLayout />
            </AuthGuard>
        ),
        children: [
            {
                index: true,
                element: <LazyComponent Component={PageDashboard} />,
            },
            {
                path: 'vehicles',
                element: <LazyComponent Component={PageVehicles} />,
            },
            {
                path: 'stations',
                element: <LazyComponent Component={PageStations} />,
            },
            {
                path: 'stops',
                element: <LazyComponent Component={PageStops} />,
            },
            {
                path: 'dispatch',
                element: <LazyComponent Component={PageDispatch} />,
            },
            {
                path: 'monitor',
                element: <LazyComponent Component={PageMonitor} />,
            },
            {
                path: 'logs',
                element: <LazyComponent Component={PageLogs} />,
            },
            {
                path: 'settings',
                element: <LazyComponent Component={PageSettings} />,
            },
        ],
    },
    {
        path: '*',
        element: <Navigate to="/" replace />,
    },
];

export default routes;
